import { useTranslation } from 'react-i18next';
import TopAppBar from '../../components/feature/TopAppBar';
import BottomTabBar from '../../components/feature/BottomTabBar';
import MetricsCard from '../../components/cards/MetricsCard';

export default function Earnings() {
  const { t } = useTranslation();
  
  const todayEarnings = {
    total: '847',
    deliveries: 12,
    avgTime: '18',
    bonus: '120',
  };
  
  const weeklyData = [
    { day: t('mon'), amount: 650 },
    { day: t('tue'), amount: 720 },
    { day: t('wed'), amount: 580 },
    { day: t('thu'), amount: 890 },
    { day: t('fri'), amount: 1050 },
    { day: t('sat'), amount: 1200 },
    { day: t('sun'), amount: 847 },
  ];
  
  const maxAmount = Math.max(...weeklyData.map(d => d.amount));
  
  const recentDeliveries = [
    { id: 'DOM2851', time: '19:45', amount: '92', duration: '16 min' },
    { id: 'DOM2849', time: '19:15', amount: '82', duration: '14 min' },
    { id: 'DOM2847', time: '18:50', amount: '89', duration: '18 min' },
    { id: 'DOM2845', time: '18:20', amount: '95', duration: '21 min' },
    { id: 'DOM2843', time: '17:55', amount: '78', duration: '15 min' },
  ];
  
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <TopAppBar title={t('earnings')} />
      
      <div className="pt-14 px-4">
        <div className="bg-gradient-to-br from-[#E31837] to-[#C41530] rounded-3xl p-6 shadow-lg mb-6 mt-4">
          <p className="text-white/90 text-sm font-semibold mb-2">{t('todaysEarnings')}</p>
          <p className="text-white text-4xl font-bold mb-4">{todayEarnings.total} SEK</p>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <i className="ri-shopping-bag-3-line text-white/90"></i>
              <span className="text-white text-sm">{todayEarnings.deliveries} {t('deliveries')}</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-white/90"></i>
              <span className="text-white text-sm">Ø {todayEarnings.avgTime} min</span>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-3 mb-6">
          <MetricsCard
            icon="ri-trophy-line"
            value={`${todayEarnings.bonus} SEK`}
            label={t('bonusToday')}
            color="green"
          />
          <MetricsCard
            icon="ri-calendar-check-line"
            value={`${weeklyData.reduce((sum, d) => sum + d.amount, 0)} SEK`}
            label={t('thisWeek')}
            color="blue"
          />
        </div>
        
        <div className="bg-white rounded-2xl p-4 shadow-md mb-6">
          <h3 className="text-base font-bold text-gray-900 mb-4">{t('weekOverview')}</h3>
          <div className="flex items-end justify-between gap-2 h-40">
            {weeklyData.map((data, index) => {
              const height = (data.amount / maxAmount) * 100;
              const isToday = index === weeklyData.length - 1;
              return (
                <div key={data.day} className="flex-1 flex flex-col items-center gap-2">
                  <div className="relative w-full flex items-end justify-center" style={{ height: '120px' }}>
                    <div
                      className={`w-full rounded-t-lg transition-all ${
                        isToday ? 'bg-[#E31837]' : 'bg-gray-200'
                      }`}
                      style={{ height: `${height}%` }}
                    ></div>
                  </div>
                  <p className={`text-xs font-semibold ${isToday ? 'text-[#E31837]' : 'text-gray-600'}`}>
                    {data.day}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
        
        <div className="bg-white rounded-2xl p-4 shadow-md">
          <h3 className="text-base font-bold text-gray-900 mb-4">{t('recentDeliveries')}</h3>
          <div className="space-y-3">
            {recentDeliveries.map((delivery) => (
              <div key={delivery.id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                <div>
                  <p className="text-sm font-mono font-bold text-gray-900">#{delivery.id}</p>
                  <p className="text-xs text-gray-600">{delivery.time} • {delivery.duration}</p>
                </div>
                <p className="text-base font-bold text-[#E31837]">+{delivery.amount} SEK</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <BottomTabBar />
    </div>
  );
}
